import React, { useMemo } from 'react';

import { Box, Tab, Tabs } from '@mui/material';
import { Navigate, Route, Routes as RoutesComponent, useLocation, useNavigate } from 'react-router-dom';

import { Categories } from './Categories';
import { Mapping } from './Mapping';
import { Questions } from './Questions';
import {
  PAGE_ADMINISTRATION,
  PAGE_ADMINISTRATION_FAQ,
  PAGE_ADMINISTRATION_FAQ_CATEGORIES,
  PAGE_ADMINISTRATION_FAQ_MAPPING,
  PAGE_ADMINISTRATION_FAQ_QUESTIONS,
} from '../../Routes';

export const Faq: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = useMemo(
    () => [
      { label: 'Категории', path: PAGE_ADMINISTRATION_FAQ_CATEGORIES },
      { label: 'Вопросы', path: PAGE_ADMINISTRATION_FAQ_QUESTIONS },
      { label: 'Маппинг', path: PAGE_ADMINISTRATION_FAQ_MAPPING },
    ],
    [],
  );

  const activeTab = useMemo(() => {
    const index = tabs.findIndex(({ path }) => location.pathname.endsWith(path));
    return index >= 0 ? index : 0;
  }, [location.pathname, tabs]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    navigate(`${PAGE_ADMINISTRATION}/${PAGE_ADMINISTRATION_FAQ}/${tabs[newValue].path}`);
  };

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        aria-label="FAQ навигация"
        sx={{ mb: 3, '& .MuiTab-root': { textTransform: 'none', minWidth: 120 } }}
      >
        {tabs.map((tab) => (
          <Tab key={tab.path} label={tab.label} />
        ))}
      </Tabs>

      <RoutesComponent>
        <Route path={PAGE_ADMINISTRATION_FAQ_CATEGORIES} element={<Categories />} />
        <Route path={PAGE_ADMINISTRATION_FAQ_QUESTIONS} element={<Questions />} />
        <Route path={PAGE_ADMINISTRATION_FAQ_MAPPING} element={<Mapping />} />
        <Route
          path="*"
          element={
            <Navigate
              replace
              to={`${PAGE_ADMINISTRATION}/${PAGE_ADMINISTRATION_FAQ}/${PAGE_ADMINISTRATION_FAQ_CATEGORIES}`}
            />
          }
        />
      </RoutesComponent>
    </Box>
  );
};
